/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.25 3.75C1.25 1.679 2.929 0 5 0h2.5c2.071 0 3.75 1.679 3.75 3.75v16.5c0 2.0711-1.679 3.75-3.75 3.75H5c-2.071 0-3.75-1.6789-3.75-3.75V3.75Zm2.75.5c0-.8284.6716-1.5 1.5-1.5h1.25c.8284 0 1.5.6716 1.5 1.5V9.5c0 .8284-.6716 1.5-1.5 1.5H5.5C4.6716 11 4 10.3284 4 9.5V4.25Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.5 21.25c.8284 0 1.5-.6716 1.5-1.5V14.5c0-.8284-.6716-1.5-1.5-1.5h-1.25c-.8284 0-1.5.6716-1.5 1.5v5.25c0 .8284.6716 1.5 1.5 1.5h1.25Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 24c2.0711 0 3.75-1.6789 3.75-3.75V3.75C22.75 1.679 21.0711 0 19 0h-2.25C14.6789 0 13 1.679 13 3.75v16.5c0 2.0711 1.6789 3.75 3.75 3.75H19Zm2.25-3.75c0 1.2426-1.0074 2.25-2.25 2.25h-2.25c-1.2426 0-2.25-1.0074-2.25-2.25V3.75c0-1.2426 1.0074-2.25 2.25-2.25H19c1.2426 0 2.25 1.0074 2.25 2.25v16.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuSubConfigManagementFilled'
);
